export const loyaltyTypesKeys = {
  cashback: 'cashback',
  pedidos: 'pedidos',
  valor_acumulado: 'valor_acumulado',
};

export const cashbackModoKeys = {
  por_pedido: 'por_pedido',
  percentual: 'percentual',
  meta_valor: 'meta_valor',
};

export const rewardTypesKeys = {
  desconto_fixo: 'desconto_fixo',
  desconto_percentual: 'desconto_percentual',
  frete_gratis: 'frete_gratis',
  cashback: 'cashback',
};

export const selectLoyaltyTypeData = [
  { value: loyaltyTypesKeys.cashback, label: 'Cashback' },
  { value: loyaltyTypesKeys.pedidos, label: 'Quantidade de pedidos' },
  { value: loyaltyTypesKeys.valor_acumulado, label: 'Valor acumulado' },
];

export const selectCashbackModoData = [
  { value: cashbackModoKeys.por_pedido, label: 'Valor fixo a cada pedido' },
  { value: cashbackModoKeys.percentual, label: 'Percentual do valor gasto' },
  { value: cashbackModoKeys.meta_valor, label: 'Ao acumular um valor em compras' },
];

export const selectRewardTypeData = [
  { value: rewardTypesKeys.desconto_fixo, label: 'Desconto em R$' },
  { value: rewardTypesKeys.desconto_percentual, label: 'Desconto em %' },
  { value: rewardTypesKeys.frete_gratis, label: 'Frete grátis' },
  { value: rewardTypesKeys.cashback, label: 'Cashback' },
];

export const durationPresetKeys = {
  sem_prazo: 'sem_prazo',
  seis_meses: 'seis_meses',
  um_ano: 'um_ano',
  personalizado: 'personalizado',
};

export const selectDurationPresetData = [
  { value: durationPresetKeys.sem_prazo, label: 'Sem prazo' },
  { value: durationPresetKeys.seis_meses, label: '6 meses' },
  { value: durationPresetKeys.um_ano, label: '1 ano' },
  { value: durationPresetKeys.personalizado, label: 'Personalizado' },
];

export const durationPresetDays = {
  [durationPresetKeys.seis_meses]: 182,
  [durationPresetKeys.um_ano]: 365,
};

export const defaultFormState = {
  id: null,
  status: true,
  type: '',
  name: '',
  description: '',
  validityDays: '',
  durationPreset: durationPresetKeys.sem_prazo,
  durationCustomDays: '',
  cashbackModo: '',
  cashbackFixedValue: '',
  cashbackPercentage: '',
  cashbackGoalValue: '',
  goalQuantity: '',
  goalValue: '',
  rewardType: '',
  rewardValue: '',
  rewardPercentage: '',
};

export const formStateKeys = Object.keys(defaultFormState).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});
